import { ViewportConfigIn } from './types/viewport-config.type';

export const viewportDefaults: ViewportConfigIn = {
	// Zoom settings 100% with autozoom's enabled
	zoom: 1,
	autoZoom: true,
	autoZoomOverhead: true,

	// Pan/Offset settings
	xPan: 0,
	yPan: 0,

	// Scale settings
	xScale: 1,
	yScale: 1,
	xScaleFactor: 1,
	yScaleFactor: 1,

	// Rotation settings
	rotation: 0,

	// Animation settings
	smoothZoomEnabled: true,
	smoothZoomDuration: 300,
	smoothZoomEasing: 'ease-out',
	smoothRotationEnabled: true,
	smoothRotationDuration: 300,
	smoothRotationEasing: 'ease-out',
	smoothPanEnabled: true,
	smoothPanDuration: 300,
	smoothPanEasing: 'ease-out',
	maxFPS: 30,

	// Viewport behavior
	enablePan: true,
	panSensitivity: 1,
	middleClickPanEnabled: true,
	middleClickPanSensitivity: 0.5,

	// Viewport appearance
	showGrid: false,
	showControls: false,
	showViewportInfo: false,
	gridColor: '#777',
	backgroundColor: '#f0f0f0',

	// Constraints
	minZoom: 0.1,
	maxZoom: 10,
	zoomStep: 0.05,
	zoomSnap: 0.001,

	// Fit to view settings
	fitToViewPadding: 0.15
};
